import { ParsedUrlQuery } from "querystring";
import { getFilterLabels } from "./filterLabels";
import { getFiltersFromQuery } from "./queryParams/filterQueryParams";

// Utility that takes a URL, and returns a comma separated list of the filters applied. Used in bookmarks to show the filters for a search in the bookmark list.
export default function getQueryAndFilterStringForUrl(url: string): string {
  if (!url) return "";

  // Extract the query string (everything after "?")
  const queryIndex = url.indexOf("?");
  if (queryIndex === -1) return ""; // No query params found

  const queryString = url.substring(queryIndex + 1);
  const urlSearchParams = new URLSearchParams(queryString);

  // Convert URLSearchParams to ParsedUrlQuery
  const parsedQuery: ParsedUrlQuery = {};
  urlSearchParams.forEach((value, key) => {
    parsedQuery[key] = value;
  });

  const filters = getFiltersFromQuery(parsedQuery);

  const labels = getFilterLabels(filters)
    .map((item) => item.label)
    .sort();

  const query = urlSearchParams.get("q") ?? "";

  return `${query}${labels.length ? " - " + labels.join(", ") : ""}`;
}
